import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

export const useFetchSwapData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["swapData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/admin/DRS-swap?page=${page}&limit=${limit}&searchFor=${searchFor}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchSwapDetailsData = (id?: string) => {
  return useQuery({
    queryKey: ["swapDetails", id],
    queryFn: async () => {
      if (!id) return null; // 👈 early exit inside the hook logic
      const res = await fetch3(`${url}/api/admin/DRS-swap/${id}`, "get");

      if (!res || !res.data) return res.message;
      return res.data;
    },
    enabled: !!id, // 👈 run only when id exists
    staleTime: 1000 * 60 * 5,
  });
};

type AssignPayload = {
  drsSwapId: string;
  driverId: any;
  shipmentIds?: string[];
};

export const useAssignDriver = () => {
  return useMutation({
    mutationFn: async ({ drsSwapId, driverId, shipmentIds }: AssignPayload) => {
      const res: any = await fetch5(
        `${url}/api/admin/DRS-swap/accept`,
        "PATCH",
        { drsSwapId, driverId, shipmentIds }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to assign driver");
      }
      return res.data;
    },
  });
};
